import { useNavigate } from "react-router-dom";
import { Box, Chip, IconButton } from "@mui/material";
import { ArrowBack } from "@mui/icons-material";
import styles from "./style.module.css";

const Header = ({ image, category }) => {
  const navigate = useNavigate();

  return (
    <Box className={styles.header}>
      <Box className={styles.image}>
        <img src={image} alt={"project-cover"} />
      </Box>
      <Box className={styles.back}>
        <IconButton onClick={() => navigate(-1)}>
          <ArrowBack sx={{ color: "#FFF" }} />
        </IconButton>
      </Box>
      <Box className={styles.options}>
        <Chip
          label={category}
          sx={{
            bgcolor:
              (category === "Brand" && "#EC7508") ||
              (category === "Cause" && "#05B240") ||
              (category === "Creator" && "#09B999") ||
              (category === "Media" && "#B90988"),
            color: "#FFF",
          }}
        />
      </Box>
    </Box>
  );
};

export default Header;
